export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export class ToggleSidebar {
    constructor(isOpen) {
        this.type = TOGGLE_SIDEBAR;
        this.payload = isOpen;
    }
}
